// Auth depolama şim'i: localStorage'daki 'projabze_token'/'projabze_user'
// anahtarlarını sessionStorage öncelikli okumaya yönlendirir; aynı tarayıcıda
// farklı sekmelerde farklı hesaplarla giriş yapılabilmesini sağlar.
import './utils/multiAccountAuth';
// Troika text (DXF/MTEXT) GPU SDF'ini global kapat — bazı GPU/driver'larda
// ANGLE_instanced_arrays yok → webgl-sdf-generator throw ediyor. Side-effect import.
import './utils/troikaSdfPatch';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store'; // store'un yolu
import * as THREE from 'three';

// Three.js BoundingBox/Sphere NaN uyarılarını sustur — NaN'li geometry'ler
// her render frame'de bu uyarıyı bastığı için konsol gürültüsü çok yüksek.
// BufferGeometry prototype'unu doğrudan patch'liyoruz (console.warn override
// bypass edilebiliyordu — Chrome stack/devtools dolaylı yolla geçirebilir).
if (typeof window !== 'undefined' && !window.__threeNanPatched) {
  window.__threeNanPatched = true;
  const proto = THREE.BufferGeometry.prototype;
  // computeBoundingBox: NaN tespitinde sessizce çık
  const origBox = proto.computeBoundingBox;
  proto.computeBoundingBox = function () {
    const posAttr = this.attributes?.position;
    if (posAttr?.array) {
      // Hızlı NaN tarama
      const arr = posAttr.array;
      for (let i = 0; i < arr.length; i++) {
        if (Number.isNaN(arr[i])) {
          // boundingBox'ı sıfırla ki tekrar çağrılmasın
          this.boundingBox = new THREE.Box3();
          window.__suppressedNanCount = (window.__suppressedNanCount || 0) + 1;
          return;
        }
      }
    }
    return origBox.call(this);
  };
  // computeBoundingSphere: aynı şekilde
  const origSphere = proto.computeBoundingSphere;
  proto.computeBoundingSphere = function () {
    const posAttr = this.attributes?.position;
    if (posAttr?.array) {
      const arr = posAttr.array;
      for (let i = 0; i < arr.length; i++) {
        if (Number.isNaN(arr[i])) {
          this.boundingSphere = new THREE.Sphere();
          window.__suppressedNanCount = (window.__suppressedNanCount || 0) + 1;
          return;
        }
      }
    }
    return origSphere.call(this);
  };
  console.info('[THREE-NaN-patch] BufferGeometry.computeBoundingBox/Sphere patched — NaN warnings suppressed');
}

// Debug: console'dan store.getState() çağırılabilsin
if (typeof window !== 'undefined') {
  window.__store = store;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
